import { toast } from 'react-toastify';
const MAX_NOTIFICATION = 3;
const NOTIFICATON_LIST = new Set();

export function setNotification(notificationType, notificationMessage) {
  switch (notificationType) {
    case 'error':
      if (NOTIFICATON_LIST.size < MAX_NOTIFICATION) {
        let errorNotificationId = toast.error(notificationMessage, {
          onClose: () => removeNotification(errorNotificationId),
        });
        NOTIFICATON_LIST.add(errorNotificationId);
      }
      break;

    case 'success':
      if (NOTIFICATON_LIST.size < MAX_NOTIFICATION) {
        let successNotificationId = toast.success(notificationMessage, {
          onClose: () => removeNotification(successNotificationId),
        });
        NOTIFICATON_LIST.add(successNotificationId);
      }
      break;

    case 'warning':
      if (NOTIFICATON_LIST.size < MAX_NOTIFICATION) {
        let warningNotificationId = toast.warn(notificationMessage, {
          onClose: () => removeNotification(warningNotificationId),
        });
        NOTIFICATON_LIST.add(warningNotificationId);
      }
      break;

    case 'default':
      if (NOTIFICATON_LIST.size < MAX_NOTIFICATION) {
        let defaultNotificationId = toast(notificationMessage, {
          onClose: () => removeNotification(defaultNotificationId),
        });
        NOTIFICATON_LIST.add(defaultNotificationId);
      }
      break;

    default:
      break;
  }
}
function removeNotification(id) {
  NOTIFICATON_LIST.delete(id);
}
